// Strip the common markdown tokens so one-line titles/previews read as prose,
// not syntax. Conversation rows get a worker-derived summary (already clean), but
// `last_text` fallbacks carry raw markdown - **bold**, `code`, [links], bullets,
// tables (| a | b |), and rules (---). General + cheap, not a full parser.
// (Shared by both apps' conversation lists.)
export function plainMarkdown(s: string | null | undefined): string {
  if (!s) return '';
  return s
    .replace(/```[\s\S]*?```/g, ' ')          // fenced code blocks
    .replace(/`([^`]+)`/g, '$1')              // inline code
    .replace(/!\[[^\]]*\]\([^)]*\)/g, ' ')    // images
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')  // links -> text
    .replace(/^\s{0,3}#{1,6}\s+/gm, '')       // headings
    .replace(/^\s{0,3}>\s?/gm, '')            // blockquotes
    .replace(/^[ \t]{0,3}\|?[ \t]*:?-+:?[ \t]*(?:\|[ \t]*:?-+:?[ \t]*)*\|?[ \t]*$/gm, '') // table delimiter rows (|---|:--:|)
    .replace(/^[ \t]{0,3}([-*_])(?:[ \t]*\1){2,}[ \t]*$/gm, '') // horizontal rules (---, ***, ___)
    .replace(/^\s{0,3}[-*+]\s+/gm, '')        // unordered bullets
    .replace(/^\s{0,3}\d+\.\s+/gm, '')        // ordered list markers
    .replace(/[ \t]*\|[ \t]*/g, ' ')          // table cell pipes -> space
    .replace(/(\*\*|__)(.*?)\1/g, '$2')       // bold
    .replace(/(\*|_)(.*?)\1/g, '$2')          // italic
    .replace(/~~(.*?)~~/g, '$1')              // strikethrough
    .replace(/\s+/g, ' ')                     // collapse newlines/runs
    .trim();
}
